/* tslint:disable */

/**
 */
export class VariabelLine {
    insulval?: number;
    elbows?: string[];
    gastemp?: number;
    height?: number;
    insulatedline?: string[];
    insulatedlineval?: string[];
    insulllenght?: number;
    insulvallenght?: number;
    non_insulated_line?: string[];
    non_insulated_valves?: string[];
    noninsulatevallenght?: number;
    noninsullenght?: number;
    pressuer?: number;
    tee?: string[];
    teenumber?: number;
    diameter?: number;
    idcooling?: number;
    insulationType?: number;
    storageTank?: string;
    insul?: number;
    noninsul?: number;
    elbowsnumber?: number;
    noninsulval?: number;
    teeval?: number;
    elbowval?: number;
    diameterParam?: number[];
    storageTankParam?: string[];
    insulationParam?: number[];
    insulationLineSub?: string[];
    non_insulated_lineSub?: string[];
    insulatedlinevalSub?: string[];
    non_insulated_valveSub?: string[];
    teeSub?: string[];
    elbowsSub?: string[];
    insulationlineValue?: number[];
    non_insulated_lineValue?: number[];
    insulatedlinevalValue?: number[];
    non_insulated_valValue?: number[];
    teeValue?: number[];
    elbowsValue?: number[];
    storageTankValue?: number[];
    idPipeELMT?: number[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/variabel-line.ts